import type { FreeItemTableData, PaidItemTableData } from './types';

export const initFreeItem: FreeItemTableData = { itemName: '', ticketId: [] };
export const initPaidItem: PaidItemTableData = {
  itemId: 'item1',
  itemName: '',
  taiwanPayPrice: null,
  pointPrice: null,
  reservationLimits: {
    reservationLowerLimit: null,
    reservationUpperLimit: null,
  },
  display: true,
};
